module.exports = __webpack_public_path__ + "img/img_mianshen@2x.e0a9f209.png";